import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { ReportTemplateSchemas } from "../ea.schema";
import { GetRequestBaseResponseSchema, ReportTemplatesFilterSchema } from "../ea.schema.query";

const base = "report-templates";
const rt = createEndpointBase(base);

export const reportTemplatesEndpoints = {
  reportTemplatesGet: rt({
    method: "GET",
    path: "",
    request: z.object({ filter: ReportTemplatesFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(ReportTemplateSchemas["general"]),
    description: "Retrieves a list of report templates with filtering support.",
  }),
  reportTemplatesCount: rt({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of report templates matching the filters.",
  }),
  reportTemplatesUpdate: rt({
    method: "PATCH",
    path: ":id",
    request: ReportTemplateSchemas["update"],
    response: ReportTemplateSchemas["general"],
    description: "Updates an existing report template.",
  }),
  reportTemplatesDelete: rt({
    method: "DELETE",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Deletes a report template.",
  }),
  reportTemplatesUpload: rt({
    method: "POST",
    path: "upload",
    request: z.object({
      name: z.string(),
      description: z.string().optional().default(""),
      id: z.coerce.number().optional(),
    }),
    response: z.any(),
    description: "Uploads a report template file.",
  }),
  reportTemplatesDownload: rt({
    method: "POST",
    path: "download/:filename",
    request: z.any(),
    response: z.any(),
    description: "Downloads a report template file.",
  }),
} as const;
